<template>
  <div />
</template>

<script>
export default {
  props: {
    'widget': {
      type: Object,
      required: true
    }
  },
}
</script>
